// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__NSQxw","image":"styles_image__lW7of"};